var map = {
	"./AED LOGOS-02.png": 62978,
	"./Bar.png": 25480,
	"./Big-Heart-Logo-Red.jpg": 3646,
	"./Big-Heart-Logo.png": 52141,
	"./Biohazard.png": 31720,
	"./Bonsoir-Elliot.png": 62455,
	"./Car-Show.png": 59377,
	"./Christmas-Market.png": 36460,
	"./CityCleaning.png": 12672,
	"./Council-Logo-White.png": 70207,
	"./DefibAsset1.png": 20420,
	"./DefibAsset2.png": 123,
	"./DefibAsset3.png": 42043,
	"./DefibAsset4.png": 64783,
	"./DefibAsset5.png": 27508,
	"./DefibSlide1.jpg": 36587,
	"./DefibSlide2.jpg": 54312,
	"./DefibSlide3.jpg": 89512,
	"./DefibSlide4.jpg": 54753,
	"./Josh.png": 90986,
	"./Lily.png": 75772,
	"./Olivia.png": 48288,
	"./Peppermint.png": 44037,
	"./Plumbing.png": 99755,
	"./Primark.png": 64882,
	"./Serena.png": 35000,
	"./ShopImage.png": 25414,
	"./StoreHolding.jpg": 464,
	"./StoreHoldingBanner.jpg": 71581,
	"./Superhero-Parade.png": 36530,
	"./SwanseaBid.jpg": 90321,
	"./Turtle-Bay-2.jpg": 98429,
	"./Turtle-Bay.png": 56041,
	"./VideoThumbnail.png": 66367,
	"./WasteDisposal.png": 54954,
	"./logo.png": 66949,
	"./miRewards.png": 15841,
	"./swanseaGiftCard.png": 89866,
	"./the-gamers-emporium.jpg": 85369
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 55200;